
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { SpecialtyItemProps } from ".";
import { loading, endLoading } from "store/specialty";

interface ApiSpecialtyRemoveInputProps {
    ids: number[]
}

type ApiSpecialtyRemoveOutputProps = OutputBaseProps<{ item: SpecialtyItemProps; }>;

export const apiSpecialtyRemove = async (data: ApiSpecialtyRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiSpecialtyRemoveOutputProps>("/api/specialty/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};